import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Vendor } from "../../atomic_components/types";

interface VendorNamesDropdownProps {
  options: Vendor[];
  onItemSelected: (value: Vendor) => void;
  providedSelectedValue: string;
}

const VendorNamesDropdown: React.FC<VendorNamesDropdownProps> = ({
  options,
  onItemSelected,
  providedSelectedValue,
}) => {
  const [filter, setFilter] = useState<string>("");
  const [selectedValue, setSelectedValue] = useState<string>(
    providedSelectedValue
  );

  useEffect(() => {
    setSelectedValue(providedSelectedValue);
  }, [providedSelectedValue]);

  const filteredOptions = options.filter((option) =>
    option.vendor_name.toLowerCase().includes(filter.toLowerCase())
  );

  const handleSelect = (value: string | null) => {
    console.log("logging selected option ", value);
    if (value) {
      setSelectedValue(value);
      console.log(value);
      options.forEach((option) => {
        if (option.vendor_name === value) {
          onItemSelected(option);
        }
      });
    }
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <Dropdown.Toggle
        variant="primary"
        id="dropdown-basic"
        style={{ width: "100%", fontSize: "14px" }}
      >
        {selectedValue || "Select Vendor"}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ width: "100%", maxHeight: "200px", overflowY: "auto" }}
      >
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Filter options..."
          value={filter}
          style={{ width: "100%" }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilter(e.target.value)
          }
        />
        {filteredOptions.map((option, index) => (
          <Dropdown.Item key={index} eventKey={option.vendor_name as any}>
            {option.vendor_name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default VendorNamesDropdown;
